module.exports = __webpack_public_path__ + "static/img/yytx14.a59c301.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx14.png
// module id = 886
// module chunks = 0